import PropTypes from "prop-types"
import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"
import TabNavigation from "components/tablink/tablink"
import { Card, CardBody } from "reactstrap"

class ClientActivityMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleMobileSelect = (e) => {
    const selectedLink = e.target.value;
    if (selectedLink) {
      this.props.history.push(selectedLink);
    }
  };

  render() {
    const { userdetail, isResponsive } = this.props;

    const navItems = [
      {
        id: "appointment",
        label: "Appointments",
        link: `/clients/activity/appointment/${this.props.match.params.id}/${this.props.match.params.clientId}`,
      },
      {
        id: "inbox",
        label: "Inbox",
        link: `/clients/activity/inbox/${this.props.match.params.id}/${this.props.match.params.clientId}`,
      },
      {
        id: "documents",
        label: "Documents",
        link: `/clients/activity/documents/${this.props.match.params.id}/${this.props.match.params.clientId}`,
      },
      ...(userdetail?.agentTimeZone?.isTwilioIntegrationEnabled
        ? [
            {
              id: "message",
              label: "Messages",
              link: `/clients/activity/message/${this.props.match.params.id}/${this.props.match.params.clientId}`,
            },
          ]
        : []),
      {
        id: "note",
        label: "Notes",
        link: `/clients/activity/note/${this.props.match.params.id}/${this.props.match.params.clientId}`,
      },
    ];

    const currentPath = this.props.location.pathname;

    return (
      <React.Fragment>
      
        {!isResponsive && <TabNavigation navItems={navItems} />}

       
        {isResponsive && (
        <Card className="mb-3">
            <CardBody>
                    <h6>Select Menu</h6>
                 <select
            className="form-select mb-3"
            value={navItems.find((item) => currentPath.includes(item.link.split("/clients/activity/")[1]))?.link || ""}
            onChange={this.handleMobileSelect}
          >
            {navItems.map((item) => (
              <option key={item.id} value={item.link}>
                {item.label}
              </option>
            ))}
          </select>
            </CardBody>
        </Card>
         
        )}
      </React.Fragment>
    );
  }
}
ClientActivityMenu.propTypes = {
    match: PropTypes.object,
    userdetail:PropTypes.object,
    isResponsive:PropTypes.object,
    location:PropTypes.object,
    history:PropTypes.object
}
export default withRouter(ClientActivityMenu)
